import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  uploadError: {
    id: 'jsm.attachment-field.create.uploadError',
    defaultMessage: 'Error uploading attachment',
    description: 'Message for when an error occurs during attachment upload'
  },
  uploadErrorDescription: {
    id: 'jsm.attachment-field.create.uploadErrorDescription',
    defaultMessage: 'An error occurred when uploading an attachment',
    description: 'Description on flag for when an error occurs durning an attachment upload'
  },
  uploadErrorForSizeLimit: {
    id: 'jsm.attachment-field.create.uploadErrorForSizeLimit',
    defaultMessage: "There can't be more than 50 attachments on a form at any given time.",
    description: 'Message for when uploading would exceed the maximum number of attachments on a form (50).'
  }
});